function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { AddIcon, RemoveIcon } from '../Icons';
import classNames from 'classnames';
import { t } from '../i18n';
import useId from '../utilities/useId';
export var AccordionItem = function AccordionItem(_ref) {
  var buttonClassName = _ref.buttonClassName,
    children = _ref.children,
    contentClassName = _ref.contentClassName,
    defaultOpen = _ref.defaultOpen,
    heading = _ref.heading,
    headingLevel = _ref.headingLevel,
    id = _ref.id,
    isControlledOpen = _ref.isControlledOpen,
    onChange = _ref.onChange,
    closeIconComponent = _ref.closeIconComponent,
    openIconComponent = _ref.openIconComponent;
  var contentClasses = classNames('ds-c-accordion__content', contentClassName);
  var buttonClasses = classNames('ds-c-accordion__button', buttonClassName);
  var HeadingTag = "h".concat(headingLevel);
  var isControlled = !!onChange;
  var contentId = useId('accordion-item--', id);
  var buttonId = "".concat(contentId, "__button");
  var _useState = useState(isControlled ? isControlledOpen : defaultOpen),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];

  // Set the state for opening and closing an accordion item
  var handleClick = function handleClick() {
    if (isControlled) {
      onChange();
    } else {
      setIsOpen(!isOpen);
    }
  };
  var isItemOpen = isControlled ? isControlledOpen : isOpen;
  var CloseIconComponent = closeIconComponent;
  var OpenIconComponent = openIconComponent;
  var closeIcon = /*#__PURE__*/React.createElement(CloseIconComponent, {
    className: "ds-c-accordion__button-icon",
    title: t('accordion.close'),
    ariaHidden: false,
    id: "".concat(contentId, "__icon")
  });
  var openIcon = /*#__PURE__*/React.createElement(OpenIconComponent, {
    className: "ds-c-accordion__button-icon",
    title: t('accordion.open'),
    ariaHidden: false,
    id: "".concat(contentId, "__icon")
  });
  if (heading) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeadingTag, {
      className: "ds-c-accordion__heading"
    }, /*#__PURE__*/React.createElement("button", {
      className: buttonClasses,
      "aria-expanded": isItemOpen,
      "aria-controls": contentId,
      id: buttonId,
      onClick: handleClick,
      type: "button"
    }, heading, isItemOpen ? closeIcon : openIcon)), /*#__PURE__*/React.createElement("div", {
      className: contentClasses,
      "aria-labelledby": buttonId,
      id: contentId,
      hidden: isControlled ? !isControlledOpen : !isOpen
    }, children));
  }
};
AccordionItem.defaultProps = {
  defaultOpen: false,
  headingLevel: '2',
  closeIconComponent: RemoveIcon,
  openIconComponent: AddIcon
};
export default AccordionItem;